import React from "react";
import Marty from "marty";
import Hero from "../components/Hero";
//import { Link } from "react-router";
import Embed from "../components/FluidEmbed";
import { Modal } from "react-bootstrap";
import assign from "object-assign";

let Help = React.createClass({
    getInitialState() {
        return {
            showModal: {
                video: false
            },
            current: 0,
            last: null
        };
    },
    componentWillMount() {
        if (Marty.isBrowser) {
            document.title = "eero - Help";
        }
    },
    closeModal(modal) {
        if (this.state.showModal[modal] === undefined) {
            return;
        }
        this.setState({
            showModal: assign({},
                this.state.showModal,
                {[modal]: false}
            )
        });
    },
    openModal(modal) {
        if (this.state.showModal[modal] === undefined) {
            return;
        }
        this.setState({
            showModal: assign({},
                this.state.showModal,
                {[modal]: true}
            )
        });
    },
    handleTipClick(i) {
        this.setState({
            current: i,
            last: this.state.current
        });
    },
    render() {
        return (
            <section className="eo-view help">
                <Hero className="help-hero">
                    <h1>We're here to help</h1>
                    <a href="https://support.eero.com/hc/en-us" target="_blank" className="eo-btn-outline white hover-blue">Help Center</a>
                </Hero>

                <div className="eo-padded-wrapper">
                    <section className="grid-10 simple-setup parent eo-section eo-info-panel dark eo-centered">
                        <div className="section simple-setup-copy">
                            <h2 className="eo-info-panel-header">Simple setup</h2>

                            <p className="eo-info-panel-copy">WiFi setup should be easy. With eero, simply download the app on your iOS or Android device. It’ll walk you through each step of the
                                process — quick, easy, painless.</p>
                            <div className="play-video" onClick={this.openModal.bind(this, "video")}>
                                <button className="btn-play"
                                        onClick={this.openModal.bind(this, "video")}>
                                    <span className="btn-play-icon icon eo-icon-play"/>
                                </button>
                                <span className="play-copy">Watch setup video</span>
                            </div>
                        </div>
                        <Modal dialogClassName="eo-modal video-modal" show={this.state.showModal.video}
                               onHide={this.closeModal.bind(this, "video")}>
                            <Modal.Header closeButton/>
                            <Modal.Body>
                                <Embed src="https://www.youtube.com/embed/YysjcLqinHs"/>
                            </Modal.Body>
                        </Modal>
                    </section>
                    <section className="grid-10 whats-happening parent eo-section eo-info-panel eo-centered">
                        <ul className="help-items grid-10">
                            <li className="help-item">
                                <a href="https://support.eero.com/hc/en-us/categories/201150566" target="_blank" className="help-item-content">
                                    <span className="help-icon icon eo-icon-card"/>
                                    <p className="help-item-title"><strong>Before you buy</strong></p>
                                    <p className="help-item-copy">Learn more about eero, equipment compatibility, and how to better determine how many your home needs.</p>
                                </a>
                            </li>
                            <li className="help-item">
                                <a href="https://support.eero.com/hc/en-us/categories/201150596" target="_blank" className="help-item-content">
                                    <span className="help-icon icon eo-icon-checklist"/>
                                    <p className="help-item-title"><strong>Getting started</strong></p>
                                    <p className="help-item-copy">Already have an eero system and need help getting started or connecting devices? We’ve got you covered.</p>
                                </a>
                            </li>
                            <li className="help-item">
                                <a href="https://support.eero.com/hc/en-us/categories/201150616" target="_blank" className="help-item-content">
                                    <span className="help-icon icon eo-icon-warning"/>
                                    <p className="help-item-title"><strong>Troubleshooting</strong></p>
                                    <p className="help-item-copy">Need help troubleshooting an issue? Here are some quick tips to get you back up and
                                        running.</p>
                                </a>
                            </li>
                        </ul>
                    </section>
                </div>
                <div className="eo-padded-wrapper">

                    <section className="grid-10 ask parent eo-section eo-info-panel eo-centered">
                        <div className="grid-4 grid-s-10 ask-copy">
                            <div className="ask-copy-inner">
                                <h2 className="ask-header standard">Ask us about WiFi</h2>
                                <p className="hours-info">
                                    Need help? Have feedback? Just want to talk WiFi? Reach out. <strong><a target="_blank" href="https://support.eero.com/hc/en-us/articles/207376426-How-do-I-contact-eero-support-">Hours here.</a></strong>
                                </p>
                            </div>
                        </div>
                        <div className="ask-icons">
                            <p className="grid-3 grid-s-10 ask-icon todo">
                                <span className="icon eo-icon-todo"/>
                                <span className="icon-copy todo">
                                    <strong>
                                        <a target="_blank" href="https://support.eero.com/hc/en-us/requests/new">Submit help request</a>
                                    </strong>
                                </span>
                            </p>
                            <p className="grid-3 grid-s-10 ask-icon call">
                                <span className="icon eo-icon-call"/>
                                <span className="icon-copy call">
                                    <strong><
                                        a target="_blank" href="tel:1-877-659-2347">1-877-659-2347</a>
                                    </strong>
                                </span>
                            </p>
                            {/* <p className="ask-icon"><span className="icon eo-icon-envelope"/> <span className="icon-copy"><strong><a target="_blank" href="mailto:support@eero.com">support@eero.com</a></strong></span>
                             </p>*/ }
                        </div>
                    </section>
                </div>
                <div className="eo-padded-wrapper">
                    <div className="help-cta grid-10 eo-cta">
                        <h1 className="big-text eo-cta-header standard"><span className="big-text">PUTTING OUR<br/>HEADS TOGETHER</span></h1>
                        <h2 className="eo-cta-subheader standard">TO SOLVE YOUR #WIFIPROBLEMS</h2>
                        <a href="https://support.eero.com/hc/en-us" target="_blank" className="eo-btn-outline white hover-blue">Help Center</a>
                        <a href="https://community.eero.com" target="_blank" className="eo-btn-outline white hover-blue btn-community">eero Community</a>
                    </div>
                </div>
            </section>
        );
    }
});

export default Marty.createContainer(Help, {});



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/help/Handler.js
 **/